module.exports = __webpack_public_path__ + "static/media/Press_Tablet.0a36dc6c.svg";